import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-image-preview-dialog',
  standalone: false,
  template: `
    <div class="image-preview-dialog">
      <div class="dialog-header">
        <h3 class="dialog-title">{{ data.imageName }}</h3>
        <button class="close-btn" (click)="onClose()" mat-icon-button>
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="dialog-body">
        <img [src]="data.imageSrc" [alt]="data.imageName" class="preview-image">
      </div>
    </div>
  `,
  styles: [`
    .image-preview-dialog {
      display: flex;
      flex-direction: column;
      max-width: 90vw;
      max-height: 90vh;
      overflow: hidden;
    }

    .dialog-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1.5rem;
      border-bottom: 1px solid #e1e5e9;
      background: #f8f9fa;
      flex-shrink: 0;
    }

    .dialog-title {
      font-size: 1.1rem;
      font-weight: 600;
      color: #2d3748;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 70%;
    }

    .close-btn {
      color: #718096;
    }

    .close-btn:hover {
      color: #2d3748;
      background: rgba(0, 0, 0, 0.05);
    }

    .dialog-body {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      max-height: calc(90vh - 80px);
      overflow: hidden;
      flex: 1;
    }

    .preview-image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      display: block;
    }

    ::ng-deep .image-preview-dialog {
      .mat-mdc-dialog-container {
        padding: 0 !important;
        border-radius: 16px !important;
        overflow: hidden !important;
        max-width: 90vw !important;
        max-height: 90vh !important;
      }

      .mat-mdc-dialog-surface {
        padding: 0 !important;
        border-radius: 16px !important;
        overflow: hidden !important;
      }
    }
  `]
})
export class ImagePreviewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImagePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imageSrc: string, imageName: string }
  ) {
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
